<script setup lang="ts">
import {computed, type HTMLAttributes} from 'vue'
import {RadioGroupRoot, RadioGroupRootEmits, type RadioGroupRootProps, useForwardPropsEmits} from 'radix-vue'
import {cn} from '@/shared/lib/utils'
import {radioCardGroupVariants, RadioCardGroupVariants} from "@/shared/components/ui/radio-group/";

type Props = RadioGroupRootProps & {
  cols?: RadioCardGroupVariants['cols']
  mobileCols?: RadioCardGroupVariants['mobileCols']
  class?: HTMLAttributes['class']
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false
})
const emits = defineEmits<RadioGroupRootEmits>()

const delegatedProps = computed(() => {
  const {class: _, ...delegated} = props

  return delegated
})
const useConditionalEmits = () => (event: string, ...args: unknown[]) => {
  //@ts-ignore
  if (!props.disabled) emits(event, ...args);
};

const forwarded = useForwardPropsEmits(delegatedProps, useConditionalEmits())
</script>

<template>
  <RadioGroupRoot
      :class="cn(radioCardGroupVariants({cols, mobileCols}), props.class)"
      v-bind="forwarded"
  >
    <slot/>
  </RadioGroupRoot>
</template>